var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 8.31706V4.65039L3.25 11.0671L9.66667 17.4837V13.7254C14.25 13.7254 17.4583 15.1921 19.75 18.4004C18.8333 13.8171 16.0833 9.23372 9.66667 8.31706Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyBlack);
export default __webpack_public_path__ + "static/media/replyBlack.fce1dc56.svg";
export { ForwardRef as ReactComponent };